
import {Component, Prop, Vue} from "vue-property-decorator";
import {FolderEntity} from "@fenix/file-manager-entities/file-manager-entities";

@Component({})
export default class SettingDeleteModal extends Vue {
  private visible: boolean = true;

  @Prop()
  folder!: FolderEntity;

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close-root-folder-delete')
  }

  private submitDelete(): void {
    this.$emit('submit-delete-root-folder-modal', this.folder);
    this.destroyComponent();

  }

}
